module.exports = __webpack_public_path__ + "1.4.15-unryo/img/gcp.d3b896b4.svg";